const authStorageKey = 'doraemonAuth';
const gameRiskRoles = {
	query: 'query',
	queryUnblock: 'query_unblock',
	queryEditUnblock: 'query_edit_unblock',
};

export function getAuthSession() {
	const rawSession = sessionStorage.getItem(authStorageKey);
	if (!rawSession) return null;

	try {
		const session = JSON.parse(rawSession);
		if (!session.token || isExpired(session.expiresAt)) {
			clearAuthSession();
			return null;
		}

		return session;
	} catch {
		clearAuthSession();
		return null;
	}
}

export function saveAuthSession(session) {
	sessionStorage.setItem(authStorageKey, JSON.stringify(session));
}

export function toAuthSession(data) {
	return {
		token: data.token,
		email: data.email,
		name: data.name,
		expiresAt: data.expiresAt,
		gameRiskRole: data.gameRiskRole,
		gameRiskPermissions: data.gameRiskPermissions,
	};
}

export function clearAuthSession() {
	sessionStorage.removeItem(authStorageKey);
}

export function getGameRiskRole() {
	return getAuthSession()?.gameRiskRole || gameRiskRoles.query;
}

export function canQueryGameRisk() {
	return true;
}

export function canEditGameRisk() {
	return getGameRiskRole() === gameRiskRoles.queryEditUnblock;
}

export function canUnblockGameRisk() {
	const role = getGameRiskRole();
	return role === gameRiskRoles.queryUnblock || role === gameRiskRoles.queryEditUnblock;
}

function isExpired(expiresAt) {
	if (!expiresAt) return true;
	return new Date(expiresAt).getTime() <= Date.now();
}
